import { CreateFormStrategy } from '../create-form.interface';

export class RenameProjectStrategy implements CreateFormStrategy {
  readonly header = 'create-form.project.rename-project';
  readonly namePlaceholder = 'create-form.project.project-name-placeholder';
  readonly createButtonLabel = 'create-form.project.buttons.rename-project';
  readonly cancelButtonLabel = 'create-form.project.buttons.cancel';
}
